"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="user-list-page">
    <crud-table title="${'user.listTitle'.t()}" addText="${'user.addUser'.t()}" resource="user" searchPlaceholder="${'user.searchPlaceholder'.t()}"
      indexEndpoint="company.index" listEndpoint="user.list" deleteEndpoint="user.delete"
      editRoute="/user/edit/:id" addRoute="/user/create" :columns="${x => x.tableColumns}" defaultQ="${x => x.q}">
    </crud-table>
  </div>
</div>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let UserList = class UserList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tableColumns = [
            { key: 'name', header: 'user.name'.t() },
            { key: 'last_name', header: 'user.last_name'.t() },
            { key: 'username', header: 'user.username'.t() },
            { key: 'email', header: 'user.email'.t() },
            { key: 'parent', header: 'user.parent'.t(), formatter: (value) => (value === null || value === void 0 ? void 0 : value.name) || '-' },
            { key: 'role', header: 'user.role'.t(), formatter: (value) => `<span class="badge badge-${this.roleBadge(value)}">${this.roleText(value)}</span>` },
            { key: 'userGroup', header: 'user.form.userGroup.label'.t(), formatter: (userGroup) => userGroup ? userGroup.name : '-' },
            {
                key: 'active',
                header: 'user.status'.t(),
                formatter: (active) => {
                    const status = this.getStatusText(active);
                    const badgeClass = active ? 'success' : 'danger';
                    return `<span class="badge badge-${badgeClass}">${status}</span>`;
                }
            }
        ];
    }
    roleText(roleText) {
        return (0, backendImport_1.getRoleText)(roleText);
    }
    roleBadge(userRole) {
        switch (userRole) {
            case backendImport_1.UserRoles.SUPER_ADMIN:
                return 'danger';
            case backendImport_1.UserRoles.PARENT_USER:
                return 'warning';
            case backendImport_1.UserRoles.ENTERPRISE:
                return 'warning';
            case backendImport_1.UserRoles.USER:
                return 'primary';
            default:
                return 'secondary';
        }
    }
    getStatusText(active) {
        return active ? 'Active' : 'Inactive';
    }
    connectedCallback() {
        if (component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN) {
            this.tableColumns = [...this.tableColumns, { key: 'company', header: 'user.company'.t(), formatter: (value) => (value === null || value === void 0 ? void 0 : value.name) || '-' }];
        }
        if (this.routeParams.q) {
            this.q = this.routeParams.q;
        }
        super.connectedCallback();
    }
};
exports.UserList = UserList;
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], UserList.prototype, "q", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], UserList.prototype, "tableColumns", void 0);
exports.UserList = UserList = __decorate([
    (0, client_1.RWSView)('user-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], UserList);
UserList.defineComponent();
